"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimToSize = void 0;
function trimToSize(source, size) {
    if (!source)
        return "";
    if (source.length <= size)
        return source;
    return source.substr(0, size - 1) + "…";
}
exports.trimToSize = trimToSize;
//# sourceMappingURL=StringTools.js.map